import { useEffect, useState } from "react";

import RevolutCheckout, { WidgetPaymentsRevolutPayOptions } from "@revolut/checkout";
import "styles/paywall/revolutPay.less";

interface AppleGooglePayWidgetProps {
    orderToken: string | null;
    amountInPence: number;
    revolutEnvironment: "prod" | "sandbox";
    handlePaymentSuccess: (_orderToken: string) => void;
    handlePaymentFailure: (_orderToken: string, _errorMessage: string) => void
}

const RevolutPay = ({ orderToken, amountInPence, revolutEnvironment, handlePaymentFailure, handlePaymentSuccess }: AppleGooglePayWidgetProps) => {
    const [amount, setAmount] = useState(0);

    const target = document.getElementById("revolut-pay");

    useEffect(() => {
        const buttonsRendered = target?.hasChildNodes();
        if (!orderToken || !amountInPence || !revolutEnvironment || !target || buttonsRendered || (amount === amountInPence)) {
            return;
        }
        setAmount(amountInPence);
        const loadWidget = async () => {
            const { revolutPay } = await RevolutCheckout.payments({
                locale: "en",
                publicToken: process.env.REACT_APP_REVOLUT_PUBLIC_MERCHANT_KEY || "",
                mode: revolutEnvironment,
            });

            const paymentOptions: WidgetPaymentsRevolutPayOptions = {
                currency: "GBP",
                totalAmount: amountInPence,
                createOrder: async () => {
                    return { publicId: orderToken };
                },
                mobileRedirectUrls: {
                    success: `${process.env.REACT_APP_BASE_URL}/uk/questionnaire?paymentStatus=success`,
                    failure: `${process.env.REACT_APP_BASE_URL}/uk/questionnaire?paymentStatus=failure`,
                    cancel: `${process.env.REACT_APP_BASE_URL}/uk/questionnaire?paymentStatus=cancelled`,
                },
            };

            revolutPay.mount(target, paymentOptions);

            revolutPay.on("payment", (event: any) => {
                switch (event.type) {
                case "success":
                    handlePaymentSuccess(orderToken);
                    break;

                case "error":
                    handlePaymentFailure(orderToken, event.error);
                    break;
                }
            });
        };

        loadWidget();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [amountInPence, orderToken, handlePaymentFailure, handlePaymentSuccess, target]);

    return (
        <>
            <div id={"revolut-pay"} className="revolut-pay-button"></div>
        </>
    );
};

export default RevolutPay;
